import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, CircularProgress, Switch } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../core/BaseComponents/Modal";
import { FaHotel } from "react-icons/fa";
import { ScrollToTop, isValidRole } from "../../../utils/utils";
import { faImages, faLink } from '@fortawesome/free-solid-svg-icons';
import { FileUploader } from "react-drag-drop-files";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DeletePartnerConfig from "./DeletePartnerConfig";
import EnableDisablePartnerConfig from "./EnableDisablePartnerConfig";
import Custom_Paingation from "../../core/BaseComponents/Custom_Paingation";
import ImageResolutionTooltip from "../ConfigurationNewHotel/ImageResolutionTooltip";

function PartnerConfiguration() {
  const [partnerConfigList, setPartnerConfigList] = useState([]);
  const [confirmDeletePartnerRow, setConfirmDeletePartnerRow] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deletePartnerPopUp, setDeletePartnerPopUp] = useState(false);
  const [editPartnerConfig, setEditPartnerConfig] = useState(false);
  const [editPartnerRowUpdate, setEditPartnerRowUpdate] = useState(false);
  const [createPartnerSuccessMsg, setCreatePartnerSuccessMsg] = useState('');
  const [editPartnerSid, setEditPartnerSid] = useState("");
  const [loader, setLoader] = useState(false);
  const [fileError, setFileError] = useState("");
  const [files, setFiles] = useState('');
  const [fileUrl, setFileUrl] = useState('');
  const [resetData, setResetData] = useState({});

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [paginationError, setPaginationError] = useState("")
  const [inputPageValue, setInputPageValue]  =useState(1)

  const recordsPerPage = 10;

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch
  } = useForm({
    mode: 'onChange',
    defaultValues: { active: true }
  });

  let validPermissionClassName = isValidRole("MASTER_CONFIG_OTT_APPS_MODIFY")
    ? ""
    : "btn-disable-permission";

    const oTTAppLogo = [
      {
        name: "OTT App Logo",
        files: 1,
        size: "700 KB",
        height: "170 or larger",
        width: "170 or larger",
        resolution: "72 PPI",
        aspect: "1:01",
        formats: "JPG, JPEG, PNG",
      }
    ]

  const onSubmit = (data) => {
    if (fileUrl === '') {
      setFileError('OTT App logo is required');
      return;
    }
    if(fileError!==""){
      return;
    }
    const formData = new FormData();
    formData.append('logo', files);
    let method = "POST";
    let url = `/master/partner?partnerTitle=${data?.partnerTitle?.replace(/\+/g, "%2B")}&partnerUrl=${data?.partnerUrl?.replace(/\+/g, "%2B")}&active=${data?.active}`;
    if (editPartnerRowUpdate) {
      method = "PUT"
      url = `/master/partner/${editPartnerSid?.sid}?partnerTitle=${data?.partnerTitle?.replace(/\+/g, "%2B")}&partnerUrl=${data?.partnerUrl?.replace(/\+/g, "%2B")}&active=${data?.active}`;
    }

    callAPI(url, method, formData)
      .then(function (response) {
        setLoader(false);
        reset({
          partnerTitle: '',
          active: true,
          partnerUrl: ''
        });
        setFileUrl('');
        setFiles('');
        setCreatePartnerSuccessMsg(response?.message);
        PartnerListApi();
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  };

  const isPartnerDeletedRef = useRef({
    isPartnerDeletedModalData: null,
    userConformationModalData: null,
  });

  const deletePartnerConfigPopUpHandler = (row) => {
    setDeletePartnerPopUp(true);
    const newModalRefData = {
      isPartnerDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isPartnerDeletedRef.current = newModalRefData;
  }

  const deletePartnerHandler = () => {
    setConfirmValidate(true);
    if (confirmDeletePartnerRow === "") {
      return
    }

    if (confirmDeletePartnerRow === `Delete ${isPartnerDeletedRef.current?.isPartnerDeletedModalData.row.logoTitle}`) {
      setConfirmValidate(false)
      const { row } = isPartnerDeletedRef.current?.isPartnerDeletedModalData;
      callAPI(`/master/partner/${row?.sid}`, "DELETE")
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isPartnerDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isPartnerDeletedRef.current = newModalRefData;
          PartnerListApi();
        })
        .catch((error) => {
          console.warn(error)
        });
    }
    reset({
      partnerTitle: '',
      active: true,
      partnerUrl: ''
    });
    setFileUrl('');
    setFiles('');
  }

  const renderActionIcon = (row) => {
    return (
      isValidRole("MASTER_CONFIG_OTT_APPS_MODIFY")?<>
        {!row?.active?<><Tooltip title="Edit" arrow>
          <MdModeEditOutline
            className="edit-icon-enable"
            onClick={() => { setEditPartnerConfig(true); setEditPartnerSid(row) }}
          />
        </Tooltip>
        <Tooltip title="Delete" className="cursor-pointer" arrow>
          <DeleteIcon
            className="delete-icon-enable"
            onClick={() => {
              deletePartnerConfigPopUpHandler(row);
            }}
          />
        </Tooltip></>:
        <>
          <Tooltip title="Disable to perform actions" arrow>
            <span><MdModeEditOutline className="edit-icon-disable" /></span>
          </Tooltip>
          <Tooltip title="Disable to perform actions" arrow>
            <DeleteIcon className="delete-icon-disable"/>
        </Tooltip>
        </>
        }

        <EnableDisablePartnerConfig row={row} setLoader={setLoader} PartnerListApi={PartnerListApi}/>
      </>:<>
            <Tooltip title="Don't have permission to edit">
                <span>
                    <MdModeEditOutline className="edit-icon-disable" arrow />
                </span>
            </Tooltip>
            <Tooltip title="Don't have permission to delete">
                <DeleteIcon className="delete-icon-disable" arrow />
            </Tooltip>
            <Tooltip title="Don't have permission to edit">
                <span>
                <Switch
                name="active"
                disabled={true}
                // onChange={(event) => handleToggleChange(event, props?.row)}
                inputProps={{ "aria-label": "controlled" }}
                value={row.active}
                checked={row.active}
                className={`${row.active === false ? 'switchuser-inactive' : 'switchuser-active'}`}
                />
                </span>
        </Tooltip>
        </>
    );
  };

  const columns = [
    { field: "createdDate", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
    { field: "logoTitle", headerName: "OTT App Name", flex: 1 },
    { field: 'logoUrl', headerName: 'OTT App Logo', flex: 1, row: true, renderCell: (row) => (<img src={row?.logoUrl} alt={row?.sid} className="partner-config-img" />), disableSortIcon: true, },
    { field: 'actionUrl', headerName: 'Package ID', flex: 1, row: true, renderCell: (row) => (<Tooltip title={row?.actionUrl}>
      {/* <a href={row?.actionUrl} target="_blank" rel="noopener noreferrer" className={`text-black d-block ${row?.actionUrl.length > 10 ? 'overflow-ellipsis' : ''}`}> */}
        {row?.actionUrl}
        {/* </a> */}
        </Tooltip>) },
    {
      field: "actionCell",
      row: true,
      headerName: "Actions",
      flex: 0.5,
      renderCell: renderActionIcon,
      sortDirection: false,
      disableSortIcon: true,
    },
  ];

  //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value)
    setPaginationError("")
    setSelectedPage(value);
  };

  const PartnerListApi = () => {
    // const apiPath = `banner/search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`;
    callAPI(`/master/partnerSearch?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`, "POST", {})
      .then((response) => {
        setPartnerConfigList(response?.partnerReponse)
        setTotalPageCount(response?.totalPages?response?.totalPages:1)
        setPaginationError("")
      })
      .catch((err) => console.warn(err.message));
  };

  useEffect(() => {
    PartnerListApi();
  }, [selectedPage]);


  const popupCloseHandler = () => {
    setDeletePartnerPopUp(false);
  };


  useEffect(() => {
    if (editPartnerConfig) {
      getPartnerListSidHandler();
      setEditPartnerConfig(false);
    }
    ScrollToTop();
    setFileError('');
  }, [editPartnerConfig]);

  const getPartnerListSidHandler = () => {
    callAPI(`/master/partner/${editPartnerSid?.sid}`, "GET")
      .then(function (response) {
        const payload = {
          partnerTitle: response?.logoTitle,
          active: response?.active,
          partnerUrl: response?.actionUrl
        };
        setFileUrl(response?.logoUrl);
        reset(payload);
        setResetData(response?.logoUrl)
        setEditPartnerRowUpdate(true);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
      });
  }

  const resetLayoutHandler = () => {
    reset();
    setFileUrl(resetData);
    setFileError('');
  }

  const cancelPartnerHandler = () => {
    reset({
      partnerTitle: '',
      active: true,
      partnerUrl: ''
    });
    setFileUrl('');
    setFiles('');
    setEditPartnerRowUpdate(false);
    setEditPartnerSid('');
    setEditPartnerConfig(false);
    setFileError('');
  }

  const handleSwitchChange = (checked) => {
    setValue("active", checked);
  };

  const uploadOrDragFileHandler = (fileList) => {
    let bytes = (fileList.size / 1024).toFixed(2);
    setFileUrl(URL.createObjectURL(fileList));
    if (bytes > 700) {
      setFileError('Upload file should be less than 700KB');
      return;
    }
    setFiles(fileList);
    setFileError('');
  }
  const deleteLogoHandler = () => {
    setFiles('');
    setFileUrl('');
    setFileError('');
  };
  return (
    <div className='row config-hotel config-management-form'>
      <div className='col-12 left-column'>
        {loader && <div className="circular-progress"><CircularProgress /></div>}
        <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className="hotel-list-form">
          <div className="row">
            <div className="left-column-header">
              <p className="Roboto-Bold">{editPartnerRowUpdate ? 'Edit OTT Apps Configuration' : 'OTT Apps Configuration'}</p>
            </div>
            <div className="col-6">
              <div className="form-group-hotel">
                <div className="floating-label">
                  <FaHotel className="new-hotel-icons" />
                  <input
                    id="partnerTitle"
                    maxLength={25}
                    placeholder=""
                    {...register("partnerTitle", {
                      required: "OTT App Title Required",
                    })}
                  />
                  <label htmlFor="partnerTitle">OTT App Title</label>
                </div>
                {errors.partnerTitle && (
                  <small className="required">{errors.partnerTitle.message}</small>
                )}
              </div>
              <div className="form-group-hotel">
                <div className="floating-label">
                  <FontAwesomeIcon icon={faLink} className="new-hotel-icons" />
                  <input
                    id="partnerUrl"
                    placeholder=""
                    {...register("partnerUrl", {
                      required: "Package ID is required",
                    })}
                  />
                  <label htmlFor="partnerUrl">Package ID</label>
                </div>
                {errors.partnerUrl && (
                  <small className="required">{errors.partnerUrl.message}</small>
                )}
              </div>
              {/* <div className="form-group-hotel">
                <div className="floating-label">
                  <FaFileUpload className="new-hotel-icons" />
                  <div>
                    <input
                      id='logos'
                      accept="image/*"
                      type="file"
                      placeholder=""
                      {...register("logos", {
                        required: "Enter Url",
                      })}
                      className="upload-logo"
                    />
                  </div>
                  <span htmlFor="logos" className="browse-content">Upload your logos here</span>
                </div>
                {errors.logos && (
                  <small className="required">{errors.logos.message}</small>
                )}
              </div> */}
              <div className="status-switch">
                <p className="mb-0">OTT App Status</p>
                <label htmlFor="active">{!watch("active") ? "Disabled" : "Enabled"}</label>
                <Switch
                  id="active"
                  className={`form-control border-0 ${!watch("active")
                    ? "switchuser-inactive"
                    : "switchuser-active"
                    }`}
                  checked={watch("active")}
                  onChange={handleSwitchChange}
                  {...register("active")}
                />
              </div>
            </div>
            <div className="col-6">
              {fileUrl !== "" ? <div className="partner-logo">
                <img src={fileUrl} alt={fileUrl} />
                <span onClick={() => deleteLogoHandler()}>X</span>
              </div>
                : <FileUploader
                  name="file"
                  types={["JPG", "PNG", 'JPEG']}
                  handleChange={uploadOrDragFileHandler}
                  classes="drag-file file-upload-bg"
                  children={
                    <>
                      <FontAwesomeIcon icon={faImages} className="fa-lg" />
                      <p className="drag-text">
                        Drag and drop logo or
                        <span> Browse</span>
                        <br />
                        To upload <span className="Roboto-Bold text-black">OTT App Logo</span> here.
                      <ImageResolutionTooltip data={oTTAppLogo}/>
                      </p>
                      {/* <h6> Formats Supported : JPG, JPEG and PNG</h6> */}
                    </>
                  }
                />
              }

              {fileError && <p className="required">{fileError}</p>}
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="button" className="clear-btn me-2" onClick={cancelPartnerHandler}>{editPartnerRowUpdate ? "Cancel" : "Clear All"}</button>
            {editPartnerRowUpdate && <>
              <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
            </>}
            <button type="submit" className={`create-btn ${validPermissionClassName} `}>{editPartnerRowUpdate ? "Update" : "Create"}</button>
          </div>
        </form>
        <div className="hotel-list">
          <p><b>OTT Apps Configuration List</b></p>

          <TableWrapper
            data={partnerConfigList}
            columns={columns}
            noPagination={true}
            module="partner-config"
          />
          <Custom_Paingation
            selectedPage={selectedPage}
            totalPageCount={totalPageCount}
            paginationError={paginationError}
            inputPageValue={inputPageValue}
            setSelectedPage={setSelectedPage}
            setPaginationError={setPaginationError}
            setInputPageValue={setInputPageValue}
            onPageChange={onPageChange}
          />
        </div>
      </div>
      {deletePartnerPopUp && <DeletePartnerConfig
        deletePartnerPopUp={deletePartnerPopUp}
        isPartnerDeletedRef={isPartnerDeletedRef}
        popupCloseHandler={popupCloseHandler}
        deletePartnerHandler={deletePartnerHandler}
        setConfirmDeletePartnerRow={setConfirmDeletePartnerRow}
        confirmDeletePartnerRow={confirmDeletePartnerRow}
        confirmValidate={confirmValidate}
      />}
      <BasicModal
        popupOpen={createPartnerSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createPartnerSuccessMsg}</p>}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreatePartnerSuccessMsg(''); setEditPartnerRowUpdate(false); PartnerListApi(); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />
    </div>
  )
}

export default PartnerConfiguration;